module.exports = __webpack_public_path__ + "img/home-duckrabbit_md.eb242671.png";